import produce from "immer";

const defaultState = {
	firstName: null
};

export default function(state = defaultState, action) {
	if (action.type === 'TOKEN_REFRESHED' || action.type === 'AUTH_SUCCESSFUL')
		return produce(state, draft => {
			draft.firstName = action.firstName;
		});
	return state;

}